<script lang="ts">
  import { onDestroy } from 'svelte';

  import type { TeoCore } from '@/teoCore/TeoCore';
  import type { TeoText } from '@/teoCore/text/TeoText';

  import Editor from './Editor.svelte';

  let { teoCore }: { teoCore: TeoCore } = $props();
  let text = $state(teoCore.activeText);

  teoCore.events.addEventListener('activeTextChanged', onTextChange);

  onDestroy(() => {
    teoCore.events.removeEventListener('activeTextChanged', onTextChange);
  });

  function onTextChange(e: TeoText) {
    text = e;
  }
</script>

{#key text.id}
  <div class="h-full max-h-full">
    <Editor {text} />
  </div>
{/key}
